export default "__VITE_ASSET__Cy4zHQvZ__"